import React from 'react'
import styled from '@emotion/styled'
import Select, { Props } from 'src/components/Select'
import { P1 } from 'src/components/Typography'
import DefaultAddIcon from 'src/icons/Add'


export interface IDynamicSelectProps extends Props, IExtraElementProps, IAddItemProps {}
export interface IExtraElementProps {
  iconSrc: string | null , 
  extraText: string,
  extraAction: Function,
  isAddItemBarVisible: boolean,
  topContent?: React.ReactNode,
  bottomContent?: React.ReactNode,
  actionContent?: React.ReactNode,
}
type IAddItemProps = Omit<IExtraElementProps, 'topContent' | 'bottomContent'>

const AddItemBar = ({
  iconSrc = null,
  extraText = '',
  extraAction = ()  => {},
  isAddItemBarVisible = true
}: IAddItemProps) => {
  if(!isAddItemBarVisible) {
    return null
  }
  return  <AddButton onMouseDown={ ()=> { extraAction() }}>
    { iconSrc ?  <AddIcon src={iconSrc}/> : <DefaultAddIcon/> }
    { extraText }
  </AddButton>
}


const ExtraElement = (menu: any, {
  /* menu(children) is automatically passed by ant design  */
  iconSrc = null,
  extraText = '',
  extraAction = ()  => {},
  isAddItemBarVisible = true,
  topContent, // customized top content
  bottomContent, // customized bottom content
  actionContent
}: IExtraElementProps  ) => {
  return (
    <Menu>
      { topContent }
      { menu } 
      {
        actionContent ? actionContent : AddItemBar({
          iconSrc,
          extraText,
          extraAction,
          isAddItemBarVisible,
        })
      }
      { bottomContent }
    </Menu>
  )
}

const DynamicSelect = ({
  className = '',
  children,
  disabled = false,
  type,
  mode,
  label,
  iconSrc = '',
  extraText = '',
  extraAction = () => {},
  isAddItemBarVisible = true,
  topContent = null,
  bottomContent = null,
  actionContent = null,
  ...rest
}: IDynamicSelectProps) => {
  return (<Select
    className={className}
    type="dropdown"
    disabled={disabled}
    mode={mode}
    label={label}
    dropdownRender={(menu) => ExtraElement(menu,{
      iconSrc,
      extraText,
      extraAction,
      isAddItemBarVisible,
      topContent,
      bottomContent,
      actionContent,
    })}
    {...rest }
    >
    { children } 
  </Select>)
}

DynamicSelect.Option = Select.Option

const Menu = styled.div`
  padding-top: 15px;
`
export const AddIcon = styled.img`
  margin-right: 5px;
`

export const AddButton = styled(P1)`
  font-weight: 500;
  color: #2f8dee;
  display: flex;
  align-items: center;
  margin-left: 15px;
  cursor: pointer;
  margin-top: 10px;
  margin-bottom: 15px;
  &:hover {
    text-decoration: underline;
  }
`
export default DynamicSelect      